<script>
	// From Lucide
	import { Plus } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Plus class={iconClass} />
